<template >
  <div class="container">
    <div v-for="(spec, index) in skusData" class="spec_title" :key="spec.id + '_id'">
      <span class="label">{{spec.name}}</span>
      <el-button v-for="option in spec.leaf" :key="option.id" @click="selectSku(index, option)"
       :type="activeSku[index].option.id === option.id ? 'primary' : ''">
        {{option.value}}
      </el-button>
    </div>
  </div>
</template>
<script>
export default {
  data: () => ({
    activeSku: []
  }),
  props: {
    skusData: {
      type: Array,
      default() {
        return []
      },
    },
  },
  watch: {
    skusData: {
      deep: true,
      immediate: true,
      handler(val) {
        this.activeSku = val.map(item => ({
          spec: {value: item.name, id: item.id},
          option: {},
        }))
      },
    }
  },
  mounted(){
    
  },
  methods: {
    selectSku(index, option) {
      if (this.activeSku[index].option && this.activeSku[index].option.id === option.id) return this.activeSku[index].option = {}
      this.activeSku[index].option = option
    },
  },
}
</script>
<style lang="stylus" rel='stylesheet/stylus'>
.spec_title
  padding: 7px 10px
  line-height: 16px
  font-weight: 400
  .label
    display: inline-block
    width: 80px
</style>